import React from 'react';
import { useLanguage } from '../../context/language/LanguageContext';
import { basicEducationData } from '../../utils/basicEducationData';
import './BasicEducation.css';

const BasicEducation = () => {
    const { language } = useLanguage();
    const data = basicEducationData[language];

    return (
        <div className="basic-education-page">
            <div className="education-hero">
                <div className="education-hero-content">
                    <h1>{data.title}</h1>
                    <p className="hero-subtitle-edu">{data.subtitle}</p>
                </div>
                <div className="education-pattern"></div>
            </div>

            <div className="education-container">
                <div className="quote-card">
                    <i className="fas fa-quote-left"></i>
                    <p>{data.mainContent.quote}</p>
                    <i className="fas fa-quote-right"></i>
                </div>

                <div className="content-grid">
                    <div className="info-card introduction">
                        <h3>{language === 'my' ? 'မိတ်ဆက်' : 'Introduction'}</h3>
                        <p>{data.mainContent.introduction}</p>
                        <p>{data.mainContent.diversity}</p>
                    </div>

                    <div className="info-card curriculum">
                        <h3>{language === 'my' ? 'သင်ရိုးညွှန်းတမ်း' : 'Curriculum'}</h3>
                        <div className="subjects-list">
                            {data.curriculum.subjects.map((subject, index) => (
                                <div key={index} className="subject-item">

                                    <span className="subject-name">{subject}</span>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="info-card duration">
                        <h3>{language === 'my' ? 'သင်ကြားချိန်' : 'Duration'}</h3>
                        <p>{data.curriculum.duration}</p>
                        <div className="teachers-info">
                            <i className="fas fa-chalkboard-teacher"></i>
                            <p>{data.curriculum.teachers}</p>
                        </div>
                    </div>
                </div>

                <div className="progression-card">
                    <div className="progression-icon">
                        <i className="fas fa-graduation-cap"></i>
                    </div>
                    <p>{data.progression}</p>
                </div>
            </div>
        </div>
    );
};

export default BasicEducation;